exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td{padding:5px 10px}.company-wrapper{display:flex;justify-content:start;align-items:center;flex-wrap:wrap;gap:20px}.company-chidl1{width:50%}.company-chidl2{width:100%}.form-control[readonly]{background-color:unset}.input-cs{font-size:1em;height:34px}.new-date .selected-tag{position:absolute}.cron-query-content{display:grid;overflow-y:scroll}.dropdown-cs>input{width:fit-content}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c422f070","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/mutual-funds/reports/mf-history.vue
// module id = 690
// module chunks = 27